import { render } from "./DistributorTable.vue?vue&type=template&id=7a23a0df&scoped=true"
import script from "./DistributorTable.vue?vue&type=script&lang=js"
export * from "./DistributorTable.vue?vue&type=script&lang=js"

import "./DistributorTable.vue?vue&type=style&index=0&id=7a23a0df&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a23a0df"]])

export default __exports__